import React from 'react';

const Footer = () => {
    return (
        <footer className='footer'>
            <div className='footer-col logo-col'>
                <img src="./taltech-logo-cutout.svg" alt="Tallinn University of Technology" />
                {/*<img src="./sillamae-port.gif" alt="Port of Sillamäe" />*/}
            </div>
            <div className='footer-col'>
                <p>Notification: This is an experimental setup for measuring currents.</p>
            </div>
        </footer>
        // <div></div>
    );
};

export default Footer;